module.exports = __webpack_public_path__ + "/images/ln-hero-af-carro.0ba0911.png";